'use strict';

var $ = require('jquery');

/**
 * Scroll manager for header and sticky elements
 */
function scrollManager() {
    const $body = $('body');
    if (!$body.length) return;

    // ----------------------
    // Header behavior
    // ----------------------
    let lastScroll = $(window).scrollTop();
    let currentState = null;
    const threshold = 10;

    function handleHeaderScroll() {
        const scrollTop = $(window).scrollTop();
        const delta = scrollTop - lastScroll;
        let newState = null;

        if (scrollTop <= 50) {
            $body.removeClass('is-logo-small is-scrolling-up is-scrolling-down');
            $body.addClass('is-at-top');
            newState = 'top';
        } else {
            $body.removeClass('is-at-top');
            $body.addClass('is-logo-small');

            if (delta > threshold && scrollTop > 300) {
                newState = 'down';
            } else if (delta < -threshold && scrollTop > 50) {
                newState = 'up';
            } else {
                lastScroll = scrollTop;
                return;
            }
        }

        if (newState === currentState) {
            lastScroll = scrollTop;
            return;
        }

        $body.removeClass('is-scrolling-up is-scrolling-down');
        if (newState === 'down') $body.addClass('is-scrolling-down');
        if (newState === 'up') $body.addClass('is-scrolling-up');

        currentState = newState;
        lastScroll = scrollTop;
    }

    // ----------------------
    // General sticky bottom behavior
    // ----------------------
    function noStickyAtBottom(targetSelector, bodyClass) {
        const $target = $(targetSelector);
        if (!$target.length) return;

        function checkStickyZone() {
            const scrollTop = $(window).scrollTop();
            const windowHeight = $(window).height();
            const targetTop = $target.offset().top;

            if (scrollTop + windowHeight >= targetTop) {
                $body.addClass(bodyClass);
            } else {
                $body.removeClass(bodyClass);
            }
        }

        $(window).on('scroll resize', () => {
            window.requestAnimationFrame(checkStickyZone);
        });

        checkStickyZone(); // initial check
    }


    // ----------------------
    // Sticky CTA
    // ----------------------
    function pdpStickyCtaOnScroll(ctaSelector, bodyClass) {
        const $cta = $(ctaSelector);
        if (!$cta.length) return;

        function checkCtaVisibility() {
            const rect = $cta[0].getBoundingClientRect();
            if (rect.bottom <= 0) {
                $body.addClass(bodyClass);
            } else {
                $body.removeClass(bodyClass);
            }
        }

        $(window).on('scroll resize', () => {
            window.requestAnimationFrame(checkCtaVisibility);
        });

        checkCtaVisibility(); // initial check
    }

    // ----------------------
    // Initialize scroll events
    // ----------------------
    function initScroll() {
        $(window).on('scroll', () => {
            window.requestAnimationFrame(handleHeaderScroll);
        });
        handleHeaderScroll();
    }

    // ----------------------
    // Initialize sticky elements
    // ----------------------
    function initStickyElements() {
        // No sticky elements when footer is in view
        noStickyAtBottom('.footer__menu', 'is-at-bottom');
        // Sticky CTA PDP
        pdpStickyCtaOnScroll('.product-details-section .add-to-cart', 'is-cta-sticky');
    }

    // ----------------------
    // Public initialization
    // ----------------------
    function initialize() {
        initScroll();
        initStickyElements();
    }

    initialize();
}

module.exports = scrollManager;
